import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

class LogoFeatureCarousel extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-logo-carousel]");
    this.initFunction();
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", (event) => {
        this.initFunction();
      });
    }
  }

  initFunction() {
    if (!this.carousel) return;

    const options = {
      type: "loop",
      arrows: false,
      pagination: false,
      drag: "free",
      gap: "100px",
      autoWidth: true,
      easing: "linear",
      autoScroll: {
        speed: this.data.scrollSpeedDesktop,
      },
      breakpoints: {
        992: {
          gap: "300px",
          autoScroll: {
            speed: this.data.scrollSpeedMobile,
          },
        },
      },
    };

    this.splide = new Splide(this.carousel, options).mount({ AutoScroll });
  }
}

if (!customElements.get("section-logo-feature-carousel")) {
  customElements.define("section-logo-feature-carousel", LogoFeatureCarousel);
}
